// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { Alert, Box, Typography } from '@mui/material';

interface Props {
  primaryItemName: string;
  selectedItemName: string | null;
}

export function MergeItemHeader(props: Props) {
  return (
    <Box sx={{ px: 6 }}>
      <Alert severity="info">
        <Typography
          variant="inherit"
          component="span"
          sx={{ fontWeight: 'bold' }}
        >
          <Typography
            variant="inherit"
            component="span"
            sx={{ textDecoration: 'underline' }}
          >
            {props.primaryItemName} will be preserved
          </Typography>{' '}
          and the{' '}
          <Typography
            variant="inherit"
            component="span"
            sx={{ textDecoration: 'underline' }}
          >
            {props.selectedItemName || 'other item'} will be permanently deleted
          </Typography>
          .
        </Typography>{' '}
        All data will be migrated automatically (assets, fields, metadata, etc).
      </Alert>
    </Box>
  );
}
